export default {
  getMovie: (state) => (id) => state.movies.find((m) => m.id === id),
  getMovieByBudget: (state) => (budgetDocumentId) => state
    .movies?.find((m) => m.budgetDocumentId === budgetDocumentId),
};
